import { format } from "../util";
var ENUM = 'enum';
var enumerable = function enumerable(rule, value, source, errors, options) {
  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
  if (rule[ENUM].indexOf(value) === -1) {
    errors.push(format(options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
  }
};
export default enumerable;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rc-component/async-validator/es/rule/enum.js
// module id = 1572
// module chunks = 0